const UserActionTypes = {
  SET_USER: "user/SET_USER",
};

export default UserActionTypes;
